export default {
  table: {
    tableClass: 'table table-hover',
    ascendingIcon: 'iconsminds-up',
    descendingIcon: 'iconsminds-down'
  }
}
